import React,{useEffect,useState} from 'react';
import authApiService from "../../services/authServices";
import { Link } from "react-router-dom";


function SignUp() {
    const [city, setCity] = useState([]);

    useEffect(() => {
      
    
        const fetchCityData = async () => {
            try {
              const response = await authApiService.get("cityDetails"); // API call using authApiService
              
              if (response && response.data) {
                const sortedCities = [...response.data].sort((a, b) =>
                  String(a?.name || "").localeCompare(String(b?.name || ""), undefined, { sensitivity: "base" })
                );
                setCity(sortedCities);
              }
            } catch (error) {
              console.error("Error fetching leaderboard data:", error);
            }
          };
      
          fetchCityData();
        
    }, []); // Added dependency array to avoid infinite loop

    const handleCitySelect = (city) => {
      localStorage.setItem("selectedCity", JSON.stringify(city)); // Store city object
  };

    
    return (
        <div id="signup-box" style={{ display: 'none' }}>

        <p className="par-txt">Welcome to City Tennis League, please select your city from the bellow:</p>
        <ul id="signup-city" className="submenu flt">
                {city && city.map((cityItem) => (
                    <li key={cityItem.id}>
                        <Link
                            style={{
                                width: "360px",
                                opacity: 1,
                                overflow: "hidden",
                            }}
                            to="carter/signup"
                            onClick={() => handleCitySelect({ id: cityItem.id, name: cityItem.name })}
                           >
                            {cityItem.name}
                        </Link>
                    </li>
                ))}
            </ul>
    </div>
    );
}

export default SignUp;
